// extracted by mini-css-extract-plugin
module.exports = {"TaskLists":"TaskLists_TaskLists__1ePzG","ModalNewListInput":"TaskLists_ModalNewListInput__1yqZX"};